import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SocialShare from '../../components/SocialShare/SocialShare';
import { getManagerByGuid } from '../../api/managerService';

export default function DirectoratesDetail() {
  const { guid } = useParams();
  const [director, setDirector] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDirectorDetail = async () => {
      if (!guid) {
        setError('Müdür bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      try {
        console.log('Müdür Detay İsteği GUID:', guid);
        const response = await getManagerByGuid(guid);
        console.log('Müdür Detay Response:', response);
        if (response.isSuccess && response.data) {
          setDirector(response.data);
        } else {
          setError(response.resultMessage || 'Müdürlük bilgileri yüklenirken bir hata oluştu.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Müdür Detay Error:', err);
        setError('Müdürlük bilgileri yüklenirken bir hata oluştu.');
        setLoading(false);
      }
    };

    fetchDirectorDetail();
  }, [guid]);

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Yükleniyor... | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorate-detail">
          <div className="container py-5">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error || !director) {
    return (
      <>
        <Helmet>
          <title>Hata | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorate-detail">
          <div className="container py-5">
            <div className="alert alert-danger" role="alert">
              {error || 'Müdürlük bulunamadı'}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{director.name} - {director.departmentName} | İskenderun Belediyesi</title>
        <meta name="description" content={`${director.name} - ${director.positionName} | İskenderun Belediyesi ${director.departmentName}`} />
      </Helmet>
      <div className="directorate-detail">
        <div className="container py-5">
          <h1 className='birim'>{director.departmentName}</h1>
          <div className="directorate-detail-header">
            <div className="directorate-detail-image">
              <img src={director.pictureUrl} alt={director.name} />
            </div>
            <div className="directorate-detail-info">
              <h1>İletişim Bilgileri</h1>
              <h2>{director.name}</h2>
              <h2>{director.positionName}</h2>
              <div className="contact-info">
                <p><strong>Telefon:</strong> {director.phone}</p>
                <p><strong>Fax:</strong> {director.fax}</p>
                <p><strong>E-posta:</strong> {director.email}</p>
                <p><strong>Konum:</strong> {director.address}</p>
              </div>
            </div>
          </div>

          <div className="directorate-detail-content">
            <div className="directorate-detail-duties">
              <h3>Görev ve Sorumluluklar</h3>
              <p>{director.duties}</p>
            </div>
            <div className="directorate-detail-description">
              <h3>Misyon</h3>
              <p>{director.mission}</p>
            </div>
            <div className="directorate-detail-description">
              <h3>Vizyon</h3>
              <p>{director.vision}</p>
            </div>
          </div>

          <div className="directorate-detail-share">
            <SocialShare />
          </div>
        </div>
      </div>
    </>
  );
}